/**
 * Configuracao de ambiente da landing page.
 *
 * As URLs vem de variaveis de build (`VITE_*`) para que o mesmo codigo sirva
 * para producao e para o ambiente local, sem `if (hostname === ...)` espalhado.
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://api.naporta.club',
  appUrl: import.meta.env.VITE_APP_URL ?? 'https://app.naporta.club',
  domain: import.meta.env.VITE_DOMAIN ?? 'naporta.club',
  dpoEmail: import.meta.env.VITE_DPO_EMAIL ?? 'privacidade@naporta.club',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL ?? 'contato@naporta.club',
};

/** Formata valores em reais sem depender de biblioteca externa. */
export const formatBRL = (value) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));

export default config;
